var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { shouldCacheResponse } from '../util/cache-predicate';
import { Header } from '../util/headers';
import { updateCache } from '../util/update-cache';
import { setupCacheData } from './util';
export function defaultResponseInterceptor(axios) {
    var _this = this;
    /**
     * Rejects cache for an response response.
     *
     * Also update the waiting list for this key by rejecting it.
     */
    var rejectResponse = function (_a, responseId) {
        var storage = _a.storage, waiting = _a.waiting;
        return __awaiter(_this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: 
                    // Update the cache to empty to prevent infinite loading state
                    return [4 /*yield*/, storage.remove(responseId)];
                    case 1:
                        // Update the cache to empty to prevent infinite loading state
                        _c.sent();
                        // Reject the deferred if present
                        (_b = waiting[responseId]) === null || _b === void 0 ? void 0 : _b.reject(null);
                        delete waiting[responseId];
                        return [2 /*return*/];
                }
            });
        });
    };
    var onFulfilled = function (response) { return __awaiter(_this, void 0, void 0, function () {
        var cacheConfig, cache, ttl, expirationTime, data, newCache, deferred;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    (_a = response.id) !== null && _a !== void 0 ? _a : (response.id = axios.generateKey(response.config));
                    (_b = response.cached) !== null && _b !== void 0 ? _b : (response.cached = false);
                    // Response is already cached
                    if (response.cached) {
                        return [2 /*return*/, response];
                    }
                    // Skip cache: either false or weird behavior
                    // config.cache should always exists, at least from global config merge.
                    if (!response.config.cache) {
                        return [2 /*return*/, __assign(__assign({}, response), { cached: false })];
                    }
                    cacheConfig = response.config.cache;
                    return [4 /*yield*/, axios.storage.get(response.id)];
                case 1:
                    cache = _c.sent();
                    if (
                    // If the request interceptor had a problem
                    cache.state === 'stale' ||
                        cache.state === 'empty' ||
                        // Should not hit here because of previous response.cached check
                        cache.state === 'cached') {
                        return [2 /*return*/, response];
                    }
                    if (!
                    // For 'loading' values (post stale), this check was already run in the past.
                    (!cache.data &&
                        !shouldCacheResponse(response, cacheConfig))) 
                    // For 'loading' values (post stale), this check was already run in the past.
                    return [3 /*break*/, 3];
                    return [4 /*yield*/, rejectResponse(axios, response.id)];
                case 2:
                    _c.sent();
                    return [2 /*return*/, response];
                case 3:
                    // avoid remnant headers from remote server to break implementation
                    delete response.headers[Header.XAxiosCacheEtag];
                    delete response.headers[Header.XAxiosCacheLastModified];
                    if (cacheConfig.etag && cacheConfig.etag !== true) {
                        response.headers[Header.XAxiosCacheEtag] = cacheConfig.etag;
                    }
                    if (cacheConfig.modifiedSince) {
                        response.headers[Header.XAxiosCacheLastModified] =
                            cacheConfig.modifiedSince === true
                                ? 'use-cache-timestamp'
                                : cacheConfig.modifiedSince.toUTCString();
                    }
                    ttl = cacheConfig.ttl || -1;
                    if (!(cacheConfig === null || cacheConfig === void 0 ? void 0 : cacheConfig.interpretHeader)) return [3 /*break*/, 6];
                    expirationTime = axios.headerInterpreter(response.headers);
                    if (!(expirationTime === 'dont cache')) return [3 /*break*/, 5];
                    return [4 /*yield*/, rejectResponse(axios, response.id)];
                case 4:
                    _c.sent();
                    return [2 /*return*/, response];
                case 5:
                    ttl = expirationTime === 'not enough headers' ? ttl : expirationTime;
                    _c.label = 6;
                case 6:
                    data = setupCacheData(response, cache.data);
                    if (!(typeof ttl === 'function')) return [3 /*break*/, 8];
                    return [4 /*yield*/, ttl(response)];
                case 7:
                    ttl = _c.sent();
                    _c.label = 8;
                case 8:
                    newCache = {
                        state: 'cached',
                        ttl: ttl,
                        createdAt: Date.now(),
                        data: data
                    };
                    // Update other entries before updating himself
                    if (cacheConfig === null || cacheConfig === void 0 ? void 0 : cacheConfig.update) {
                        updateCache(axios.storage, response, cacheConfig.update);
                    }
                    deferred = axios.waiting[response.id];
                    // Resolve all other requests waiting for this response
                    return [4 /*yield*/, (deferred === null || deferred === void 0 ? void 0 : deferred.resolve(newCache.data))];
                case 9:
                    // Resolve all other requests waiting for this response
                    _c.sent();
                    delete axios.waiting[response.id];
                    // Define this key as cache on the storage
                    return [4 /*yield*/, axios.storage.set(response.id, newCache)];
                case 10:
                    // Define this key as cache on the storage
                    _c.sent();
                    // Return the response with cached as false, because it was not cached at all
                    return [2 /*return*/, response];
            }
        });
    }); };
    return {
        onFulfilled: onFulfilled,
        apply: function () { return axios.interceptors.response.use(onFulfilled); }
    };
}
